<template>
     <div>
      <h1>{{ $t('help.ISACloseFollowUpHelp_title') }}</h1>
      <p class="text-justify">
          {{ $t('The Close Follow-up feature enables you to get a live footage in the room. This buton activates or desactivates Close Follow-up for a whole care unit.') }}
      </p>
      
    </div>
</template>

<script>

export default  {
  components: {    
  },  
  data() {
    return {      
    }
  },
  watch : {    
  },    
  methods: {        
    },
  mounted() {            
  },
  name: "ISAHelpModalContent"
}
</script>

<style lang="scss" scoped>
h1 {
  font-weight: 700;
}

.modal-title {
  font-weight: 700;
}

</style>
